<template>
    <v-card class="d-flex flex-column justify-space-between" width="350" height="110"  style="position: relative">
        <div style="width: 180px; height: 120px; position: absolute; top: -3px; right: -25px;">
            <apex-chart type="radialBar" :options="chartData" :series="series"></apex-chart>
        </div>
        <div class="px-3 pt-2 text-start body-1 font-weight-thin ">
            Online Devices
        </div>
        <div class="px-4 pb-2 caption grey--text ">
            {{onlineDevicesWithAccess}} of {{totalDevices}} Devices Currently Online
        </div>
        <div class="flex-grow-1"></div>
        <div class="d-flex justify-space-between">

        </div>
        <div class="px-3 pb-1 text-h4 font-weight-light d-flex align-center">
            <v-icon large left>mdi-cellphone-link</v-icon>
            {{onlineDevicesWithAccess}}
        </div>
    </v-card>
</template>

<script>
import {mapGetters} from "vuex";
import VueApexCharts from 'vue-apexcharts'
export default {
    components: {
        apexChart: VueApexCharts,
    },
    props: {
        propName: {
            type: Number,
            default: 0
        },
    },
    computed: {
        ...mapGetters(['devicesWithAccess', 'devicesWithAccessIds', 'onlineDeviceIds', 'employeesRef']),
        totalDevices() {
            return this.devicesWithAccess
                    .filter(device => {
                        if (device.phone)
                            return false
                      if (device.o365TenantUser)
                        return false
                        if (device.disabled)
                            return false
                        if (!device.employeeId)
                            return true
                        return !this.employeesRef[device.employeeId].disabled
                    })
                    .length
        },
        onlineDevicesWithAccess() {
            return this.onlineDeviceIds
                    .filter(deviceId => this.devicesWithAccessIds.includes(deviceId))
                    .length
        },
        series() {
            return [Math.floor(this.onlineDevicesWithAccess/this.totalDevices * 100)]
        },
        chartData() {
            const vm = this
            const opts = {
                chart: {
                    // width: 80,
                    // height: 100,
                    type: "radialBar",
                },
                plotOptions: {
                    radialBar: {
                        startAngle: -135,
                        endAngle: 135,
                        track: {
                            margin: 10,
                            background: '#333',
                            startAngle: -135,
                            endAngle: 135,
                        },
                        hollow: {
                            margin: 0,
                            size: '40%',
                            image: undefined,
                            imageOffsetX: 0,
                            imageOffsetY: 0,
                            position: 'front',
                            dropShadow: {
                                enabled: true,
                                top: 3,
                                left: 0,
                                blur: 4,
                                opacity: 0.24
                            }
                        },
                        dataLabels: {
                            enabled: false,
                            name: {show: false},
                            value: {show: false},
                        }
                    }
                },
                colors: ["var(--v-primary-darken2)"],
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        type: 'vertical',
                        shadeIntensity: 0.5,
                        gradientToColors: ['var(--v-primary-lighten1)'],
                        inverseColors: true,
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 100]
                    }
                },
                stroke: {
                    lineCap: "round"
                },
                labels: ["Progress"]
            };


            return opts
        },
    }
}
</script>

<style scoped>

</style>